import { getCtData, setData } from '../project';
import {
  collection,
  doc,
  documentId,
  getDoc,
  onSnapshot,
  orderBy,
  query,
} from 'firebase/firestore';
import { firestoreOutFlax } from '../functions/firebase/firebase';
import { proxy } from '../../globalVars/data';
import { Platform } from 'react-native';
import { TMergedLocalBikes } from './mergeLocationBikes';

type Tprops = {
  pass: {
    ipt1: any[];
    ipt2: string;
    ipt3: any[];
  };
  args?: any;
};

// ------------------ Objetivo é buscar e mostrar Dados das Bikes
// ------------------ filtrados por Ponto (loja).

// --------------------------------------------------------------
// ---------------------- MERGE DATA DE -------------------------
// --------------------------------------------------------------
// ------------------ /locations/ID/localBikes ------------------
// ------------------ com os dados de ---------------------------
// ------------------ /bikeModels -------------------------------

export const mergeListAutoBike = async (props: Tprops) => {
  // const { ipt1, ipt2 } = props.pass;
  const localBikes: TMergedLocalBikes[] = props?.args[0]; // collection 'localBikes' (código, quantidade etc)

  // -----------------------------
  // --------- ETAPA 1 - FETCH API
  // -----------------------------
  const condOS = Platform.OS === 'web';

  const url = 'http://200.234.207.52:8000/stations/';
  const apiLocationID = 'sc.B3A.currData.currLocation.data.apiLocationID';
  console.log({ apiLocationID });
  const apiId = getCtData(apiLocationID);
  const condIdAPI = apiId ?? '1';

  console.log({ apiId });

  const condURL = condOS ? proxy + url + condIdAPI : url + condIdAPI;

  const response = await fetch(condURL);
  const jsonAluguelBikes = await response.json();
  //   console.log({ jsonAluguelBikes });
  const arrRacks = jsonAluguelBikes.msg.racks;
  const onlyBikesAvailable = arrRacks.filter(
    (rack: any) => rack.status === 'lock',
  );

  // -------------------------------------
  // --------- ETAPA 2 - PEGAR NO FIREBASE
  // -------------------------------------

  // ---------- set Local Imports
  //   const { documentId } = await import('@firebase/firestore');
  const pathCurrLocationID = 'sc.B3A.currData.currLocation.data.docId';
  const currLocationID = getCtData(pathCurrLocationID);
  console.log({ currLocationID });

  const refColl = collection(
    firestoreOutFlax,
    'locations',
    currLocationID,
    'localBikes',
  );

  const q = query(refColl, orderBy('createdAt', 'desc'));

  const unsub = onSnapshot(q, async success => {
    const arrDocs = [];
    success.forEach((doc: any) => {
      arrDocs.push(doc.data());
    });

    const firstDoc = arrDocs[0] ?? {};
    const { createdAt, docId, modelCode, modelId, status } = firstDoc;

    const mergedArray = [];

    const refColl2 = collection(firestoreOutFlax, 'bikeModels');
    const refDoc2 = doc(refColl2, modelId);
    const resDoc = await getDoc(refDoc2);

    console.log({ resDoc });

    onlyBikesAvailable.forEach(i => {
      // ---- ---- ---- ----
      // ---- ---- ---- ----
      // ---- ---- ---- ----
      const arrIDsLocalBikes =
        localBikes
          .filter(
            i =>
              i?.docId && i?.status === 'available' && i?.modelId === i.docId,
          )
          .map(i => i.docId) ?? [];

      mergedArray.push({
        createdAt,
        docId,
        modelCode,
        modelId,
        status,
        rackID: i.rackID,
        rackStatus: i.status,

        modelAmount: '1',
        modelName: resDoc.data()?.modelName,
        imgUrl: resDoc.data()?.imgUrl,
        modelPrice: resDoc.data()?.modelPrice,
        allLocalIds: arrIDsLocalBikes,
      });
    });
    // ---------- set Get Value Functions
    console.log({ mergedArray });

    // ------------------------------
    //   salvar a lista principal em
    // sc.B3C.currData.mainList
    setData({ path: 'sc.B3C.currData.mainList', value: mergedArray });
    // setData({ path: 'sc.B3B.currData.mainList', value: mergedArray });
  });
};
